import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <Box className='d-flex flex-column justify-content-center align-items-center mt-5'>
      <Typography> Not Found Page </Typography>
      <Link to='/'> Go Home </Link>
    </Box>
  );
};

export default NotFound;
